<template>
<div class="svg-text">
  <img class="svg-text-inner el" :src="src_inner" alt="">
  <img class="svg-text-outer el" :src="src_outer" alt="">
</div>
</template>

<script>
import anime from 'animejs';

export default {
  name: 'svg-circle',
  data() {
    return {
      src_outer: require('@/assets/loader_outer.png'),
      src_inner: require('@/assets/loader_Overlay.png'),
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss">
.svg-text {
    img {
        z-index: 1;
        position: absolute;
        max-height: 375px;
        // -webkit-transform: translate3d(0,0,0);
    }
}
</style>
